<script setup lang="ts">
import { DiabetesCondition, PersonData, PrescribedConditionTypes } from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import diabetes from "./diabetes.json";

export interface Props {
    condition: DiabetesCondition,
    personDetails: PersonData
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: DiabetesCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm<
    {type: PrescribedConditionTypes.Diabetes} & DiabetesCondition
>({
    ...props.condition,
    type: PrescribedConditionTypes.Diabetes,
    medications: props.condition.medications || [],
    diagnosis_date: props.condition.diagnosis_date || "",
}, emit);
</script>

<template>
    <MedicalFormBuilder
        :schema="parseSchema(diabetes)"
        :initial-form="state.condition"
        :diagnosis-date="state.condition.diagnosis_date"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    />
</template>

<style>

</style>
